import { render, staticRenderFns } from "./idTrade.vue?vue&type=template&id=a21b7c24"
import script from "./idTrade.vue?vue&type=script&lang=js"
export * from "./idTrade.vue?vue&type=script&lang=js"
import style0 from "./idTrade.vue?vue&type=style&index=0&id=a21b7c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
